import templateUrl from './app.html';

export const appComponent = {
	templateUrl
};


// WEBPACK FOOTER //
// ./src/app/common/app.component.js